export const connectivityCheck = () => {
    if (navigator.onLine) {
        return true
    } else {
        return false
    }
}
